<template>
<div class="edit-wrapper">
  <div class="edit-form">
    <div class="ship-to">
      <!-- <el-card style="width: 100%;"> -->
        <div class="edit-title">Address Book<i @click="$emit('close-address-editor')" class="material-icons" style="color: #333;">clear</i></div>
        <div style="width:100%;padding:0 12px 2rem 12px;box-sizing:border-box;position:relative">
          <el-form :rules="rulesReceiver" :model="receiveInfo" ref="step2Form">
            <el-form-item label="Alias" prop="alias">
              <el-input placeholder="Enter alias for this address" v-model="receiveInfo.alias" clearable></el-input>
            </el-form-item>
            <el-form-item label="Name" prop="name">
              <el-input placeholder="Enter Recipient's Name" v-model="receiveInfo.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="Phone Number" prop="phone">
              <el-input placeholder="Enter Recipient's Phone Number" type="number" v-model="receiveInfo.phone" clearable></el-input>
            </el-form-item>
            <el-form-item label="ID Number" prop="ID">
              <el-input placeholder="Enter Recipient's ID Number" v-model="receiveInfo.ID" clearable></el-input>
            </el-form-item>
            <el-form-item label='Region' prop='province'>
              <el-row>
                <el-col :span='24' style="display:flex;">
                  <el-cascader :options="locationOption" v-model="selectedRegion" placeholder="Province / City / District" style="width:100%;"></el-cascader>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="Address" prop="addressInfo">
              <el-input placeholder="Enter Recipient's Address Info" v-model="receiveInfo.addressInfo" clearable></el-input>
            </el-form-item>
            <el-form-item label="Postal Code" prop="postal">
              <el-input placeholder="Enter Recipient's Postal Code" type="number" v-model="receiveInfo.postal" clearable></el-input>
            </el-form-item>
            <el-form-item label="Country" prop="country">
              <el-input placeholder="Enter Recipient's Country" v-model="receiveInfo.country" disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="width:100%;display:flex;flex-direction:row;padding:0px 12px;box-sizing:border-box; margin-bottom: 2rem">
          <el-button type="primary" @click="saveAddress">Save <i class="el-icon-arrow-right el-icon-right"></i></el-button>
        </div>
      <!-- </el-card> -->
    </div>
  </div>
</div>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">
import { saveAddress } from "../../../../../../GitHub/yunda-shop-system/firebase-project/app-vue-3/public/js/addressBook";

  WebFont.load({
    google: {
      families: ["Montserrat:100,100italic,200,200italic,300,300italic,400,400italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic"]
    }
  });
</script>
<script>
/* eslint-disable handle-callback-err */

import { ChinaRegion } from '../../public/js/ChinaRegion'
import { saveAddress } from '../../public/js/addressBook'

export default {
  name: 'AddressEditor',
  props: ['address'],
  data () {
    return {
      receiveInfo: this.address,
      selectedRegion: [this.address.province, this.address.city, this.address.district],
      rulesReceiver: {
        alias: [
          { required: true, message: 'Please input alias', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'Please input name', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Please input phone number', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]*$/, message: 'Phone number should be digits only', triger: 'change' },
          { min: 11, max: 11, message: 'Phone number should be 11 digits', triger: 'change' }
        ],
        addressInfo: [
          { required: true, message: 'Please input address', trigger: 'blur' }
        ],
        province: [
          { required: true, message: 'Please select region', trigger: 'change' }
        ],
        postal: [
          { required: true, message: 'Please input postal code', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]*$/, message: 'Postal code should be digits only', triger: 'change' },
          { min: 6, max: 6, message: 'Postal code should be 6 digits', triger: 'change' }
        ],
        ID: [
          { required: true, message: 'Please input reveiver\'s ID', trigger: 'blur' },
          { type: 'string', pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/, message: 'Please enter valid ID number', triger: 'blur' }
        ]
      },
      locationOption: ChinaRegion,
      warningTxt: ''
    }
  },
  methods: {
    saveAddress: function () {
      let address = this.receiveInfo
      address.province = this.selectedRegion[0]
      address.city = this.selectedRegion[1]
      address.district = this.selectedRegion[2]
      // console.log('save address', address)
      let that = this
      return saveAddress(address).then(() => {
        // console.log('address updated')
        that.$emit('close-address-editor')
        that.$message({
          message: 'Your address book has been updated.',
          type: 'success'
        })
      }).catch(err => {
        // console.log(err)
        that.$message({
          message: 'Save address failed, please try again.',
          type: 'danger'
        })
      })
    }
  }
}

</script>

<style scoped>
p {
    text-align: left;
}
h2 {
  font-size: 35pt;
}
.add-title {
  width:560px;
  display:flex;
  flex-direction:row;
  justify-content: space-between;
  align-items: center;
  padding:32px 0 12px 0;
  font-size:16px;
  font-weight:bold;
  border-bottom:1px solid #e0e0e0;
  box-sizing:border-box;
  position: fixed;
  top: 10vh;
  left: auto;
  right: auto;
  background-color: #ffffff;
  z-index: 1100;
}
.el-form-item {
  display: flex;
  flex-direction: column;
}
.el-form-item__label {
  position: relative;
  text-align: left !important;
}
.font-bold {
  font-weight: bold;
}
.form-header {
  padding: 0 20px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
}
.form-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: medium;
}
.back-home {
  font-size: 18px;
  color: whitesmoke;
  font-weight: normal;
  cursor: pointer;
}
.studio-s {
  margin-left: 4px;
  font-size: medium;
  color: #c62828;
  text-decoration: none;
}
.form-main {
  padding: 64px 120px;
}
.step1{
  padding-top: 56px;
  margin: auto;
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.from-shop {
  width: 48%;
}
.from-home {
  width: 48%;
}
.step2 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.ship-to {
  width: 100%;
  margin: auto;
}
.step3 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.pack-detail {
  width: 48%;
  margin: auto;
}
.specSelect {
  width: 200px;
}
.step4 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.add-info {
  width: 48%;
  margin: auto;
}
.step5 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.confirm-info {
  width: 48%;
  margin: auto;
}
.order-success {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background-color: rgba(77,77,77,0.4);
  z-index: 1001;
  animation: showConfirm 0.4s ease;
}
.success-info {
  color: rgba(0, 0, 0, 0.6);
  width: 800px;
  height: 70vh;
  margin: auto;
  background-image: url(../../public/images/yunda-b-6.jpg);
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  overflow: auto;
}
.fail-info {
  color: rgba(0, 0, 0, 0.6);
  width: 800px;
  height: 70vh;
  margin: auto;
  background-image: url(../../public/images/yunda-back.jpg);
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  overflow: auto;
}
.success-image {
  width: 780px;
  height: 18vh;
  border-radius: 5PX 5px 0 0;
  color: rgba(49, 49, 49, 0.2);
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  display: flex;
  align-items:flex-start;
  justify-content: flex-end;
}
.success-content {
  width: 100%;
  height: 49.5vh;
  border-radius: 0 0 5px 5px;
}
@keyframes showConfirm {
  from { opacity: 0; }
  to { opacity: 1; }
}
@media (max-width: 1440px) {
  .step1{
    width: 95%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .step2{
    margin: auto;
    width: 95%;
  }
  .step3{
    margin: auto;
    width: 95%;
  }
  .step4{
    margin: auto;
    width: 95%;
  }
  .step5{
    margin: auto;
    width: 95%;
  }
  .from-shop {
    width: 60%;
  }
  .from-home {
    margin-top: 16px;
    width: 60%;
  }
  .ship-to {
    width: 100%;
  }
  .pack-detail {
    width: 60%;
  }
  .add-info {
    width: 60%;
  }
  .confirm-info {
    width: 60%;
  }
  .el-card__body {
    padding: 20px 4px;
  }
}
@media (max-width: 1024px) {
  .form-main {
    padding: 24px 12px;
    font-size: small;
  }
  .step1{
    width: 95%;
    margin: auto;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
  }
  .step2{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step3{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step4{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step5{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .from-shop {
    width: 100%;
  }
  .from-home {
    margin-top: 16px;
    width: 100%;
  }
  .ship-to {
    width: 100%;
  }
  .pack-detail {
    width: 100%;
  }
  .add-info {
    width: 100%;
  }
  .confirm-info {
    width: 100%;
  }
  .el-card__body {
    padding: 20px 4px;
  }
}
@media (max-width: 812px) {
  .specSelect {
    width: 80px;
  }
  .el-message-box {
    width: 300px;
  }
  .el-step__title {
    font-size: 14px;
  }
  .success-info {
  color: rgba(0, 0, 0, 0.6);
  width: 95%;
  height: 95vh;
  margin: auto;
  background:url(../../public/images/yunda-b-7.jpg);
  background-size: right;
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.success-image {
  width: 100%;
  border-radius: 5PX 5px 0 0;
  color: rgba(49, 49, 49, 0.2);
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  display: flex;
  align-items:flex-start;
  justify-content: flex-end;
}
.success-content {
  width: 100%;
  border-radius: 0 0 5px 5px;
}
}
</style>
